import http from '@/utils/http.js'
import Api from '@/conf/Api';
import notify from '@/utils/notify'
import Router from "@/router";

// GETs
export function LOAD_JOB({ commit }, data) {
  return http.get(Api.job + data)
    .then((res) => {
      if (res.data) commit('SET_JOB', res.data);
      else commit('user/SET_LOGOUT', {}, { root: true })
      return res.data
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}
export function IMPRODUTIVO({ commit }, data) {
  return http.put(Api.admin.jobs.improdutivo.replace("?", data.id), data).then((e) => notify(commit, e)).catch((e) => notify(commit, e))
}
export function LOAD_JOB_CANDIDATE({ commit }, token) {
  return http.get(Api.supporter.candidate + token)
    .then((res) => {
      if (res && res.data) {
        commit('SET_JOB', res.data);
        return res.data
      }

      if (res && res.msg)
        notify(commit, res)


    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function SET_CANDIDATE({ commit }, token) {
  return http.post(Api.supporter.setcandidate + token)
    .then((res) => {
      notify(commit, res)
      Router.push('/supporter/candidaturas')
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function CANDIDATOS({ commit }, ID) {
  return http.post(Api.admin.jobs.candidatos.replace('?', ID), { status: 'na_fila' })
    .catch((e) => (notify(commit, e), e))
}

export function DETALHA_FECHAMENTO({ commit }, ID) {
  return http.get(Api.admin.jobs.detalhaFechamento.replace('?', ID))
    .catch((e) => (notify(commit, e), e))
}
export function REMOVE_SUPPORTER({ commit }, data) {
  return http.put(Api.admin.jobs.remove_doutor.replace('?', data.id), data)
    .then((e) => (notify(commit, e), e))
    .catch((e) => (notify(commit, e), e))
}

export function RESCENDIR_ALOC({ commit }, data) {
  return http.put(Api.admin.jobs.rescindirAloc.replace('?', data.id), { motivo_cancelamento: data.motivo })
    .then((e) => (notify(commit, e), e))
    .catch((e) => (notify(commit, e), e))
}

export function DESCARTAR({ commit }, data) {
  return http.put(Api.admin.jobs.descartar.replace('?', data.job) + data.id, { motivo_descarte: data.motivo_descarte })
    .catch((e) => (notify(commit, e), e))
}
export function SELECIONA_CANDIDATO({ commit }, data) {
  return http.put(Api.admin.jobs.selecionaCandidato.replace('?', data.job) + data.id)
    .catch((e) => (notify(commit, e), e))
}
export function DIVULGA({ commit }, ID) {
  return http.put(Api.admin.jobs.divulga.replace('?', ID))
    .then((e) => (notify(commit, e), e))
    .catch((e) => (notify(commit, e), e))
}
export function AGENDA({ commit }, ID) {
  return http.post(Api.admin.jobs.agenda.replace('?', ID))
    .catch((e) => (notify(commit, e), e))
}

export function CANCELA_AGENDA({ commit }, data) {
  return http.put(Api.admin.jobs.agenda_cancela.replace('?', data.id), data)
    .then((e) => (notify(commit, e), e))
    .catch((e) => (notify(commit, e), e))
}

export function CANCELA_FECHAMENTO({ commit }, ID) {
  return http.post(Api.admin.jobs.cancela_fechamento.replace('?', ID))
    .then((e) => (notify(commit, e), e))
    .catch((e) => (notify(commit, e), e))
}
// eslint-disable-next-line no-empty-pattern
export function LOAD_ORIENTATION({ }, data) {
  return http.get(Api.supporter.orientation.get + data)
    .then((res) => {
      return res.data
    })
}
export function LOAD_ORIENTATION_DEFAULT({ commit }) {
  return http.get(Api.orientation_default.get)
    .then((res) => {
      return res.data
    }).catch((e) => {
      notify(commit, e)
    })
}

export function COST_LIMIT({ commit }, ID) {
  return http.get(Api.admin.jobs.costLimit.replace("?", ID)).catch((e) => {
    notify(commit, e)
  })
}
// eslint-disable-next-line no-empty-pattern
export function LOAD_ATTENDANCE({ }, data) {
  return http.get(Api.supporter.attendance.replace('?', data))
    .then((res) => res.data).catch(e => (e.status == 404) ? [] : false)
}

export function LOAD_ATTENDANCE_ID({ commit }, id) {
  return http.get(Api.attendance + '/' + id + '/chegada')
    .then((res) => {
      return res.data;
    }).catch((e) => {
      notify(commit, e)
    })
}

export async function FATURAVEL({ commit }, ID) {
  return http.put(Api.admin.jobs.faturamento.replace('?', ID), { faturavel: true, motivo_nao_faturavel: "Faturável." })
    .then((res) => {
      notify(commit, res)
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export async function NAO_FATURAVEL({ commit }, { id, motivo_nao_faturavel }) {
  return http.put(Api.admin.jobs.faturamento.replace('?', id), { faturavel: false, motivo_nao_faturavel: motivo_nao_faturavel })
    .then((res) => {
      notify(commit, res)
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function CHANGE_GD({ commit }, data) {
  return http.put(Api.admin.jobs.changeGD.replace('?', data.job) + data.id_gestor)
    .then((res) => {
      notify(commit, res)
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function SET_AGGREGATE({ commit }, data) {
  return http.put(Api.supporter.aggregate.replace('?', data.job), { id_agregado_doutor: data.id })
    .then((res) => {
      notify(commit, res)
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function REMOVE_AGGREGATE({ commit }, data) {
  return http.put(Api.supporter.remove_aggregate.replace('?', data))
    .then((res) => {
      notify(commit, res)
      return res
    }).catch((e) => {
      notify(commit, e)
    })
}

// SETs
export function SET_ORIENTATION({ commit }, data) {
  return http.put(Api.supporter.orientation.set.replace('?', data), { msg: 'Confirmada orientação para job' })
    .then((res) => {
      return res.data
    }).catch((e) => {
      notify(commit, e)
    })
}

export function SET_DESLOCATION({ commit }, data) {
  return http.put(Api.supporter.deslocation.replace('?', data), { msg: 'Deslocamento iniciado' })
    .then((res) => {
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function SET_CHECKIN({ commit }, data) {
  return http.put(Api.supporter.checkin.replace('?', data), { msg: 'Checkin realizado' })
    .then((res) => {
      return res
    }).catch((e) => {
      notify(commit, e)
      return e
    })
}

export function SET_NOTE({ commit }, data) {
  if (data.tipo_nota == "") data.tipo_nota = "anotacao"
  return http.post(Api.supporter.note.set.replace('?', data.id), { nota: data.nota, tipo_nota: data.tipo_nota })
    .then((res) => {
      if (res) {
        commit('SET_NOTE', data)
        return res.data
      }
    }).catch((e) => {
      notify(commit, e)
    })
}

export function COMPLEMENTO_ESCOPO(_, id) {
  return http.get(Api.supporter.note.escopo.replace('?', id))
}

export function SET_ATTACH({ commit }, data) {
  return http.post(Api.supporter.attach.replace('?', data.id), data.arquivo,
    { headers: { 'Content-Type': 'multipart/form-data' } })
    .then((res) => {
      if (res) {
        commit('SET_ATTACH', data.nota)
        return res.data
      }
    }).catch((e) => {
      notify(commit, e)
    })
}

export function SET_FINISH({ commit }, data) {
  if (data.payload.duracao_atendimento > data.duracao_atendimento)
    data.payload.fez_hora_extra = true

  return http.put(Api.supporter.finish.replace('?', data.id), data.payload)
    .then((res) => {
      if (res) {
        return res
      }
    }).catch((e) => {
      notify(commit, e)
    })
}


export function CANCEL_CANDIDATE({ commit }, id) {
  return http.delete(Api.supporter.cancelCandidate + id)
    .then((res) => {
      notify(commit, res)
      window.location.reload()
    }).catch((e) => {
      notify(commit, e)
      window.reload()
    })
}

